<template>
  <div>
    <!-- Header -->
    <HeaderComponent />

    <!-- Main content -->
    <router-view />

    <!-- Footer -->
    <FooterComponent />
  </div>
</template>

<script>
// Components
import HeaderComponent from './components/Header.vue';
import FooterComponent from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  }
};
</script>
